// Whoop OAuth config. Reads from Vite env vars.

// Whoop's token + API endpoints don't allow direct browser fetches (no CORS
// headers), and Whoop's token endpoint requires the client_secret server-side.
// In dev: requests are routed through the Vite dev server at `/whoop-token`
// and `/whoop-api/*` (configured in vite.config.ts).
// In prod: requests go to the Cloudflare Worker (see /worker/README.md).
//   Set VITE_PROD_PROXY_BASE at build time, e.g.:
//     VITE_PROD_PROXY_BASE=https://whoop-lens-auth.<you>.workers.dev
const PROD_PROXY_BASE = (
  (import.meta.env.VITE_PROD_PROXY_BASE as string | undefined) ?? ''
).replace(/\/+$/, '')

const TOKEN_PATH = '/whoop-token'
const API_PATH = '/whoop-api/developer'

// Authorize URL is a top-level browser navigation (not a fetch), so CORS
// doesn't apply — we hit Whoop directly.
export const WHOOP_AUTH_URL = 'https://api.prod.whoop.com/oauth/oauth2/auth'
export const WHOOP_TOKEN_URL = import.meta.env.DEV
  ? TOKEN_PATH
  : `${PROD_PROXY_BASE}${TOKEN_PATH}`
export const WHOOP_API_BASE = import.meta.env.DEV
  ? API_PATH
  : `${PROD_PROXY_BASE}${API_PATH}`

export const WHOOP_SCOPES = [
  'offline', // required for Whoop to return a refresh_token
  'read:recovery',
  'read:cycles',
  'read:workout',
  'read:sleep',
  'read:profile',
  'read:body_measurement',
].join(' ')

export const CLIENT_ID = import.meta.env.VITE_WHOOP_CLIENT_ID as string

export function getRedirectUri(): string {
  // Same origin + /callback. Whitelist this exactly in your Whoop OAuth app.
  return `${window.location.origin}/callback`
}

if (!CLIENT_ID) {
  // Soft warning: app still loads, login button will explain.
  // eslint-disable-next-line no-console
  console.warn('VITE_WHOOP_CLIENT_ID is not set. Copy .env.example to .env and fill it in.')
}
